import "./PumperList.css";
import SlidableComponent from "../../shared/SlidableComponent/SlidableComponent";

const PumperList = ({ data }) => {
  return (
    <div className={"pumperListWrapper"}>
      {data?.map((item, index) => {
        return (
          <SlidableComponent
            key={index}
            i={++index}
            data={[item]}
            title={"Насос"}
            grid={[
              { key: "arrowLength", label: "Длина стрелы" },
              { key: "objectHeight", label: "Высота площадки" },
              { key: "objectWidth", label: "Ширина площадки" },
              { key: "pipes", label: "Трубы" },
            ]}
            list={[
              { key: "isTubeRequired", label: "Нужен шланг" },
              { key: "isLinePump", label: "Линейный насос" },
              { key: "commentary", label: "Комментарий" },
            ]}
          />
        );
      })}
    </div>
  );
};

export default PumperList;
